import { ExternalOrderLine } from "@api/throughShipment/throughShipmentApi";
import tryallPackageSetSkuHandle from "@utils/Tryall/tryallPackageSetSkuHandle";

type RevenueItem = { requestQty: number };

const safeGetPackageQty = (sku: string): number => {
  try {
    const [qty] = tryallPackageSetSkuHandle(sku);
    return qty;
  } catch {
    return 1;
  }
};

/** 依外部訂單明細計算總箱數、總 Pcs 數與總需求量；usePackageSet 為 true 時會依 SET 包裝規則換算數量 */
export default function calculatePieces(
  externalOrderLine: ExternalOrderLine[],
  externalOrdersRevenueLists: RevenueItem[],
  usePackageSet = false,
): { key: string; value: string | number }[] {
  let orderedCartonQty = 0;
  let totalPcs = 0;
  let totalRequestQty = 0;

  externalOrderLine
    .filter((item) => item.orderedQty > 0)
    .forEach((item) => {
      const multiplier = usePackageSet ? safeGetPackageQty(item.no) : 1;
      orderedCartonQty += (item.orderedQty * multiplier) / item.pcsPerCarton;
      totalPcs += item.orderedQty;
    });

  if (externalOrdersRevenueLists.length > 0) {
    totalRequestQty = externalOrdersRevenueLists.reduce((acc, cur) => acc + cur.requestQty, 0);
  }

  return [
    { key: "總箱數", value: orderedCartonQty.toFixed(1) },
    { key: "總Pcs數", value: totalPcs },
    { key: "總需求量", value: totalRequestQty },
  ];
}
